import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import XHR from "i18next-xhr-backend";
import languageEN from "locate/en/translate.json";
import languageFA from "locate/fa/translate.json";

// const DETECTION_OPTIONS = {
//   order: ["localStorage", "navigator"],
//   // cache user language on
//   caches: ["localStorage"],
// };

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: languageEN,
      fa: languageFA,
    },
    /* default language when load the website in browser */
    lng: "fa",
    /* When react i18next not finding any language to as default in borwser */
    fallbackLng: "fa",
    /* debugger For Development environment */
    debug: true,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
    react: {
      wait: true,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed",
      nsMode: "default",
    },
    // detection: DETECTION_OPTIONS,
  });

export default i18n;
